<template>
  <div class="new_settlement">
    <div class="settlement_top">
      <el-row>
        <div class="top_model">
          <div>
            <span>结算批次名称:</span>
            <span class="settlementName">{{
              addForm.settlementBatchName
            }}</span>
            <span style="margin-left: 10px">金额:</span>
            <span class="settlementName">{{ pageTotalMoney }}</span>
          </div>
          <div>
            <span>质保金额:</span>
            <span class="settlementName">{{ totalsData.warrantyAmount }}</span>
            <span>已缴纳金额:</span>
            <span class="settlementName">{{ totalsData.paidAmount }}</span>
            <span>剩余金额:</span>
            <span class="settlementName">{{ totalsData.remainAmount }}</span>
            <span style="margin-left: 30px">结算师傅: </span>
            <span>{{ addForm.responsibleUserIdStr }}</span>
          </div>
        </div>
      </el-row>
    </div>
    <!-- 安装费用 -->
    <div class="install_cont">
      <div class="install_title" style="display: flex; justify-content: space-between; align-items: center">
        <div style="display: flex; align-items: center">
          <div style="white-space: nowrap">
            <span>安装费用: {{ installationCost }}</span>
            <span v-if="contTableData.length > 0" style="margin-left: 10px"
              >订单数量: {{ contTableData.length }};</span
            >
            <span style="margin-inline: 15px">|</span>
            <span style="font-size: 12px"
              >用线米数：{{ totalsData.lineLength }}</span
            >
            <span style="margin-left: 10px; font-size: 12px"
              >增项费用：{{ totalsData.addOutlay }};</span
            >
            <span style="margin-left: 10px; font-size: 12px"
              >平均米数：{{ contTableData.length > 0 ? (totalsData.lineLength / contTableData.length).toFixed(2) : '0.00' }}</span
            >
            <span style="margin-left: 10px; font-size: 12px"
              >平均增项：{{ contTableData.length > 0 ? (totalsData.addOutlay / contTableData.length).toFixed(2) : '0.00' }}</span
            >
          </div>
          <div>
            <span style="margin-inline: 15px">|</span>
            <span
              v-for="(item, index) in contTableDataGroupTotal"
              :key="index"
              style="margin-right: 15px; font-size: 12px; display: inline-block"
            >
              {{
                item.installerIdStr +
                `(${item.children.length}单): ${item.totalInstallFee}元;`
              }}
            </span>
          </div>
        </div>
        <div v-show="!addForm.isSee">
          <el-button
            type="danger"
            size="mini"
            :disabled="!addForm.id || Number(addForm.status) !== 3"
            @click="handleApplyLatestGroup('installationFee')"
            >应用最新数据及群组</el-button
          >
        </div>
      </div>

      <div>
        <el-form :inline="true" class="form" size="mini">
          <el-form-item label="客户名称">
            <el-input
              style="width: 200px"
              v-model="contTableDataFilteredKeys.customerName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input
              style="width: 200px"
              v-model="contTableDataFilteredKeys.contactInfo"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="车架号">
            <el-input
              style="width: 200px"
              v-model="contTableDataFilteredKeys.vin"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="品牌">
            <el-input
              style="width: 200px"
              v-model="contTableDataFilteredKeys.brandIdStr"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="车型">
            <el-input
              style="width: 200px"
              v-model="contTableDataFilteredKeys.carModelIdStr"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="主机厂号">
            <el-input
              style="width: 200px"
              v-model="contTableDataFilteredKeys.mainOrderNo"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="上游编号：">
            <el-input
              style="width: 200px"
              v-model="contTableDataFilteredKeys.upstreamOrderNo"
              placeholder="请输入"
            ></el-input
          ></el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="contTableDataFilteredSearch"
              size="mini"
              >查询</el-button
            >
            <el-button
              type="info"
              @click="contTableDataFilteredRest"
              size="mini"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div v-loading="installationFeeLoading" element-loading-text="正在应用最新数据及群组...">
        <BaseTable
          :tableData="contTableDataFiltered"
          :max-height="400"
          :isSerialNumber="true"
          :columns="contColumns"
        ></BaseTable>
      </div>
    </div>
    <!-- 正负激励 -->
    <div class="install_cont">
      <div class="install_title">
        <span>正/负激励: {{ motivateNum }}</span>
      </div>
      <div class="motivate">
        <p class="motivate_title" style="margin: 0">
          <!-- #79d72e -->
          <span style="margin-right: 20px"
            >正激励:
            <i style="font-style: normal; font-weight: 700; color: #79d72e">{{
              straightNum
            }}</i></span
          >
          <span
            >负激励:
            <i style="font-style: normal; font-weight: 700; color: #dc362e">{{
              burdenNum == 0 ? 0 : "-" + burdenNum
            }}</i></span
          >
        </p>
        <div>
          <el-button
            type="primary"
            size="mini"
            style="margin-right: 5px; margin-bottom: 5px"
            v-show="!addForm.isSee"
            @click="showDialog('straight')"
            >新增正激励</el-button
          >
          <el-button
            type="warning"
            size="mini"
            style="margin-right: 5px; margin-bottom: 5px"
            @click="showDialog('burden')"
            v-show="!addForm.isSee"
            >新增负激励</el-button
          >
        </div>
      </div>
      <BaseTable
        :tableData="settlementIncentiveList"
        :columns="straightColumns"
        :isSerialNumber="true"
        :max-height="400"
        :showOperationColumn="addForm.isSee ? false : true"
        :rowKey="'index'"
      >
        <template #incentiveType="{ row }">
          <span>{{ row.incentiveType ? "正激励" : "负激励" }}</span>
        </template>
        <template #attachmentIds="{ row }">
          <span v-if="row.attachmentIds && row.attachmentIds.length > 0">
            <el-button
              type="text"
              size="small"
              @click="seeFileList(row.attachmentIds)"
              >{{ row.attachmentIds.length }}</el-button
            >
          </span>
        </template>
        <template #incentiveAttachmentIds="{ row }">
          <span
            v-if="
              row.incentiveAttachmentIds &&
              row.incentiveAttachmentIds.length > 0
            "
          >
            <el-button
              type="text"
              size="small"
              @click="seeFileList(row.incentiveAttachmentIds)"
              >{{ row.incentiveAttachmentIds.split(",").length }}</el-button
            >
          </span>
        </template>
        <template #relatedOrderIds="{ row }">
          <span v-if="row.relatedOrderIds && row.relatedOrderIds.length > 0">
            <el-button
              type="text"
              size="small"
              @click="seeRelatedOrderIds(row.relatedOrderIds)"
              >{{ row.relatedOrderIds.split(",").length }}</el-button
            >
          </span>
        </template>
        <template #operation="{ row }">
          <el-tooltip effect="dark" content="修改" placement="top-end">
            <el-button
              type="warning"
              icon="el-icon-edit"
              size="mini"
              @click="edit(row, row.incentiveType ? 'straight' : 'burden')"
              style="margin: 0 5px"
              circle
            ></el-button>
          </el-tooltip>
          <el-tooltip effect="dark" content="删除" placement="top-end">
            <el-popconfirm
              title="确认删除吗？"
              @confirm="deleteData(row, 'settlementIncentiveList')"
            >
              <el-button
                content="删除"
                slot="reference"
                type="danger"
                icon="el-icon-delete"
                circle
                size="mini"
              ></el-button>
            </el-popconfirm>
          </el-tooltip>
        </template>
      </BaseTable>
    </div>
    <!-- 物料费用 -->
    <div class="install_cont">
      <div class="motivate">
        <p class="motivate_title" style="margin: 0; font-weight: 700">
          物料费用: {{ materialNum > 0 ? "-" + materialNum : 0 }}
        </p>
        <div><el-button
          type="primary"
          size="mini"
          style="margin-right: 5px; margin-bottom: 5px"
          @click="showDialog('material')"
          v-show="!addForm.isSee"
          >新增</el-button
        >
        <el-button
          type="success"
          size="mini"
          style="margin-right: 5px; margin-bottom: 5px"
          @click="copyMaterial"
          v-show="!addForm.isSee"
          >复制</el-button
        ></div>
      </div>
      <BaseTable
        :tableData="materialData"
        :isSerialNumber="true"
        :isSelection="true"
        :columns="materialColumns"
        :max-height="400"
        :showOperationColumn="addForm.isSee ? false : true"
        :rowKey="'index'"
        @selection-change="handleMaterialSelectionChange"
      >
        <template #attachmentIds="{ row }">
          <span v-if="row.attachmentIds && row.attachmentIds.length > 0">
            <el-button
              type="text"
              size="small"
              @click="seeFileList(row.attachmentIds)"
              >{{ row.attachmentIds.length }}</el-button
            >
          </span>
        </template>
        <template #operation="{ row }">
          <el-tooltip effect="dark" content="修改" placement="top-end">
            <el-button
              type="warning"
              icon="el-icon-edit"
              size="mini"
              @click="edit(row, 'material')"
              style="margin: 0 5px"
              circle
            ></el-button>
          </el-tooltip>
          <el-tooltip effect="dark" content="删除" placement="top-end">
            <el-popconfirm
              title="确认删除吗？"
              @confirm="deleteData(row, 'materialData')"
            >
              <el-button
                content="删除"
                slot="reference"
                type="danger"
                icon="el-icon-delete"
                circle
                size="mini"
              ></el-button>
            </el-popconfirm>
          </el-tooltip>
        </template>
      </BaseTable>
    </div>
    <!-- 管理费用/其他 -->
    <div class="install_cont" v-if="manageData.length > 0 || isManagementFeeGroupLeader">
      <div class="install_title" style="display: flex; justify-content: space-between; align-items: center">
        <div style="display: flex; align-items: center">
          <div style="white-space: nowrap">
            <span>管理费用: {{ manageCont }}</span>
            <span
              v-if="manageData.length > 0"
              style="margin-left: 15px; margin-right: 40px"
              >订单数量: {{ manageData.length }};</span
            >
          </div>
          <div>
            <span
              v-for="(item, index) in manageDataGroupTotal"
              :key="index"
              style="margin-right: 15px; font-size: 12px; display: inline-block"
            >
              {{
                item.installerIdStr +
                `(${item.children.length}单): ${item.totalManageFee}元;`
              }}
            </span>
          </div>
        </div>
        <div v-show="!addForm.isSee">
          <el-button
            type="danger"
            size="mini"
            :disabled="!addForm.id || Number(addForm.status) !== 3"
            @click="handleApplyLatestGroup('manageFee')"
            >应用最新数据及群组</el-button
          >
        </div>
      </div>

      <div v-loading="manageFeeLoading" element-loading-text="正在应用最新数据及群组...">
        <BaseTable
          :tableData="manageData"
          :columns="manageColumns"
          :isSerialNumber="true"
          :max-height="400"
        ></BaseTable>
      </div>
    </div>
    <div class="install_cont">
      <div class="install_title" style="position: relative">
        <span>其他: {{ otherTotal }}</span>
        <el-button
          type="primary"
          size="mini"
          style="position: absolute; right: 5px; top: -5px"
          @click="showDialog('other')"
          v-show="!addForm.isSee"
          >新增</el-button
        >
      </div>
      <BaseTable
        :tableData="otherData"
        :isSerialNumber="true"
        :columns="otherColumns"
        :max-height="400"
        :showOperationColumn="addForm.isSee ? false : true"
        :rowKey="'index'"
      >
        <template #attachmentIds="{ row }">
          <span v-if="row.attachmentIds && row.attachmentIds.length > 0">
            <el-button
              type="text"
              size="small"
              @click="seeFileList(row.attachmentIds)"
              >{{ row.attachmentIds.length }}</el-button
            >
          </span>
        </template>
        <template #incentiveType="{ row }">
          <span>{{ row.incentiveType === 1 ? "正激励" : "负激励" }}</span>
        </template>
        <template #operation="{ row }">
          <el-tooltip effect="dark" content="修改" placement="top-end">
            <el-button
              size="mini"
              type="warning"
              icon="el-icon-edit"
              circle
              @click="edit(row, 'other')"
              style="margin: 0 5px"
            ></el-button>
          </el-tooltip>
          <el-tooltip effect="dark" content="删除" placement="top-end">
            <el-popconfirm
              title="确认删除吗？"
              @confirm="deleteData(row, 'otherData')"
            >
              <el-button
                content="删除"
                slot="reference"
                type="danger"
                icon="el-icon-delete"
                circle
                size="mini"
              ></el-button>
            </el-popconfirm>
          </el-tooltip>
        </template>
      </BaseTable>
    </div>
    <!-- 备注 -->
    <div class="install_cont">
      <div class="install_title">
        <span>备注: </span>
      </div>
      <el-form :model="remarkForm" size="small">
        <el-form-item>
          <el-input
            type="textarea"
            v-model="remarkForm.remarks"
            :disabled="addForm.isSee"
            placeholder="请输入..."
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <!-- 关联订单 -->
    <el-dialog
      title="关联订单"
      :visible.sync="relatedOrders"
      width="1100px"
      append-to-body
      :close-on-click-modal="false"
    >
      <RelatedOrders
        :dialogFlag="relatedOrders"
        :addForm="addForm"
        ref="relatedRefs"
      ></RelatedOrders>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            relatedOrders = false;
            selectOrderIds = [];
          "
          size="small"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="relatedOrdersSubmit"
          size="small"
          v-show="isSee"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 新增/编辑 -->
    <el-dialog
      :title="isNewAdd ? '新增' : '编辑'"
      :visible.sync="motivateDialog"
      width="700px"
      append-to-body
      :close-on-click-modal="false"
      @close="newAddClose"
    >
      <component
        :is="currentName"
        :ref="currentName"
        :dialogFlag="motivateDialog"
        :isStraight="isStraight"
        :responsibleUserId="addForm.responsibleUserId"
        :userList="userList"
        @related="related"
      ></component>
      <span slot="footer" class="dialog-footer">
        <el-button @click="newAddClose" size="small">取 消</el-button>
        <el-button type="primary" @click="addSubmit" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 文件列表 -->
    <FileList ref="fileListRefs"></FileList>
  </div>
</template>

<script>
import BaseTable from "@/components/BaseTable";
import RelatedOrders from "./relatedOrders.vue";
import MotivateAdd from "./motivateAdd.vue";
import Material from "./material.vue";
import Other from "./other.vue";
import Big from "big.js";
import {
  contColumns,
  straightColumns,
  manageColumns,
  otherColumns,
  materialColumns,
  tableDataCommonSearch,
  tableDataGroupAndTotal,
} from "./columns.js";
import FileList from "@/components/FileList";
export default {
  components: {
    BaseTable,
    RelatedOrders,
    MotivateAdd,
    Material,
    Other,
    FileList,
  },
  props: {
    addForm: {
      type: Object,
      default: () => {},
    },
    success: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      totalsData: {
        lineLength: 0,
        addOutlay: 0,
      },
      contTableData: [], //安装费用
      contTableDataGroupTotal: [],
      contTableDataFiltered: [],
      contTableDataFilteredKeys: {},
      pendingSettlementOrderIds: [], // 安装费用列表id
      contColumns: contColumns,
      installationCost: 0,
      installationFeeLoading: false, // 安装费应用最新数据及群组loading
      settlementIncentiveList: [], //正负激励列表参数
      manageData: [], // 管理费用
      manageDataGroupTotal: [],
      manageFeeLoading: false, // 管理费应用最新数据及群组loading
      isManagementFeeGroupLeader: false, // 是否是管理费群组管理员
      straightColumns: straightColumns,
      manageColumns: manageColumns,
      remarkForm: {
        remarks: "",
      },
      otherData: [], //其他
      otherColumns: otherColumns,
      relatedOrders: false,
      materialData: [], //物料费用
      materialColumns: materialColumns,
      selectedMaterialRows: [],
      motivateDialog: false, //正负激励新增/编辑弹窗
      currentName: "MotivateAdd", //当前弹窗组件名称
      isStraight: true, //是否是正激励
      straightNum: 0, //正激励金额
      burdenNum: 0, //正激励金额
      currentRow: {}, //当前行数据
      materialNum: 0, //物料费用
      isNewAdd: true, //是否是新增
      currentElement: "motivateFormRefs", //当前组件名称
      otherTotal: 0, //其他费用
      selectOrderIds: this.$store.state.selectOrderIds || [], //关联的订单ID
      manageCont: 0, // 管理费用
      isSee: true,
      userList: [], // 师傅列表
    };
  },
  watch: {
    addForm: {
      handler(newVal) {
        if (newVal) {
          this.success && this.getData();
          // 获取师傅列表
          this.queryMasterList();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    // 获取师傅列表
    this.queryMasterList();
  },
  computed: {
    motivateNum() {
      return new Big(this.straightNum || 0)
        .minus(new Big(this.burdenNum || 0))
        .toFixed(2);
    },
    pageTotalMoney() {
      return new Big(this.motivateNum)
        .plus(new Big(this.installationCost))
        .minus(new Big(this.materialNum))
        .plus(new Big(this.manageCont))
        .plus(new Big(this.otherTotal))
        .toFixed(2);
    },
  },
  methods: {
    handleMaterialSelectionChange(val) {
      this.selectedMaterialRows = val || [];
    },
    copyMaterial() {
      if (!this.selectedMaterialRows || this.selectedMaterialRows.length === 0) {
        this.$message.warning("请先选择要复制的物料数据！");
        return;
      }
      if (this.selectedMaterialRows.length > 1) {
        this.$message.warning("只能选择一条物料数据进行复制！");
        return;
      }
      const row = this.selectedMaterialRows[0];
      this.isNewAdd = true;
      this.currentName = "Material";
      this.currentElement = "materialFormRefs";
      this.motivateDialog = true;
      
      // 等待子组件挂载并拉取下拉后再回填
      this.$nextTick(() => {
        const materialComp = this.$refs.Material;
        if (!materialComp) return;

        // 等待下拉选项加载完成
        const waitForOptions = () => {
          return new Promise((resolve) => {
            const checkOptions = () => {
              if (materialComp.materialTypeOption && materialComp.materialTypeOption.length > 0 &&
                  materialComp.modelOptionsBackup && materialComp.modelOptionsBackup.length > 0) {
                resolve();
              } else {
                setTimeout(checkOptions, 100);
              }
            };
            checkOptions();
          });
        };

        waitForOptions().then(() => {
          // 先设置类型，触发联动
          if (row.edMaterialTypeId) {
            materialComp.materialForm.edMaterialTypeId = row.edMaterialTypeId;
            materialComp.addSelectType(row.edMaterialTypeId);
          }

          // 等待型号选项更新
          this.$nextTick(() => {
            // 设置型号
            if (row.edSettleMaterialModelId) {
              materialComp.materialForm.edSettleMaterialModelId = row.edSettleMaterialModelId;
              materialComp.addSelectModel(row.edSettleMaterialModelId);
            }

            // 最后回填其他字段
            this.$nextTick(() => {
              materialComp.materialForm.quantity = row.quantity || "";
              materialComp.materialForm.unitPrice = row.unitPrice || "";
              materialComp.materialForm.unit = row.unit || materialComp.materialForm.unit || "";
              materialComp.calculateSubtotal();
              materialComp.materialForm.remarks = row.remarks || "";
              materialComp.materialForm.orderTime = row.orderTime || "";
              // 不复制附件，保持为空数组
              materialComp.materialForm.attachmentIds = [];
            });
          });
        });
      });
    },
    tableDataGroupAndTotal,
    contTableDataFilteredSearch() {
      const keys = Object.keys(this.contTableDataFilteredKeys).map((item) => {
        return {
          key: item,
          value: this.contTableDataFilteredKeys[item],
        };
      });
      this.contTableDataFiltered = tableDataCommonSearch(
        this.contTableData,
        keys
      );
    },
    contTableDataFilteredRest() {
      Object.keys(this.contTableDataFilteredKeys).forEach((item) => {
        this.contTableDataFilteredKeys[item] = "";
      });
      this.contTableDataFiltered = this.contTableData;
    },
    seeRelatedOrderIds(ids) {
      this.isSee = false;
      const list = ids.split(",");
      const orders = list.map((item) => Number(item));
      this.$store.commit("setSelectOrderIds", orders);
      this.relatedOrders = true;
    },
    seeFileList(ids) {
      if (typeof ids === "string") {
        ids = ids.split(",");
      }
      this.$refs.fileListRefs.open(ids);
    },
    // 获得结算批次名称下的安装费用数据
    getData() {
      this.axios({
        url: "/v1/web/settlement-manage/settlement-order/get",
        method: "GET",
        params: {
          ...this.addForm,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.showData(res.data.data);
        }
      });
    },
    queryUserList(userId) {
      //获取用户列表
      this.axios({
        method: "get",
        url: "/v1/web/user-info/list-user",
        params: { masterWorker: userId, page: 1, size: 1 },
      }).then((res) => {
        if (
          res.data.code == 200 &&
          res.data.data.list &&
          res.data.data.list.length > 0
        ) {
          const { warrantyAmount, paidAmount, remainAmount } =
            res.data.data.list[0];
          this.totalsData = {
            warrantyAmount,
            paidAmount,
            remainAmount,
            lineLength: this.totalsData.lineLength,
            addOutlay: this.totalsData.addOutlay,
          };
        }
      });
    },
    queryMasterList() {
      //获取师傅下拉列表
      this.axios({
        method: "get",
        url: "/v1/web/user-info/select-master-drown",
      }).then((res) => {
        if (res.data.code == 200 && res.data.data && res.data.data.list) {
          // 处理师傅名称，只去除"（数字+单）"部分
          this.userList = (res.data.data.list || []).map(user => {
            const userName = user.userName || '';
            // 使用正则表达式匹配"（数字+单）"模式并替换为空
            const cleanUserName = userName.replace(/\(\d+单\)/g, '');
            return {
              ...user,
              userName: cleanUserName
            };
          });
        }
      });
    },
    // 计算总的安装费用
    calculateInstall() {
      this.installationCost = 0;
      this.pendingSettlementOrderIds = [];
      if (this.contTableData.length > 0) {
        this.contTableData.forEach((item) => {
          this.pendingSettlementOrderIds.push(item.id);
          const installFee = Number(item.installFee) || 0;
          this.installationCost = new Big(this.installationCost)
            .plus(new Big(installFee))
            .toFixed(2)
            .toString();
        });
      }
    },
    // 编辑时回显信息
    showData(data) {
      this.addForm.responsibleUserIdStr = data.responsibleUserIdStr;
      // 设置状态，用于判断按钮是否可用
      if (data.status !== undefined && data.status !== null) {
        this.addForm.status = data.status;
      }
      // 设置质保信息
      this.queryUserList(data.responsibleUserId);
      // 获取师傅列表
      this.queryMasterList();

      this.contTableData = data.pendingSettlementOrderList || []; //安装费用
      this.contTableDataFiltered = this.contTableData;
      this.contTableDataGroupTotal = this.tableDataGroupAndTotal(
        this.contTableData,
        "installerIdStr",
        "installFee"
      );
      this.totalsData.lineLength = this.contTableData.reduce((acc, item) => {
        if (item.lineLength !== undefined && item.lineLength !== null) {
          return acc.plus(new Big(item.lineLength || 0));
        }
        return acc;
      }, new Big(0));

      this.totalsData.addOutlay = this.contTableData.reduce((acc, item) => {
        if (item.addOutlay !== undefined && item.addOutlay !== null) {
          return acc.plus(new Big(item.addOutlay || 0));
        }
        return acc;
      }, new Big(0));
      //正负激励费用
      this.settlementIncentiveList = this.fileData(
        data.settlementIncentiveList || []
      );
      // 管理费
      this.manageData = data.settlementManageFeeList || [];
      this.manageDataGroupTotal = this.tableDataGroupAndTotal(
        this.manageData,
        "installerIdStr",
        "manageFee"
      );
      // 是否是管理费群组管理员
      this.isManagementFeeGroupLeader = data.isManagementFeeGroupLeader || false;

      this.materialData = this.fileData(data.settlementMaterialFeeList || []);
      this.otherData = this.fileData(data.settlementOtherFeeList || []);
      this.remarkForm.remarks = data.remarks || "";
      this.calculateInstall();
      this.calculateAmount();
      this.calculateMaterial();
      this.calculateOther();
      this.calculateManage();
    },
    //附件数据转换
    fileData(data) {
      data.forEach((item) => {
        if (item.attachmentIds && typeof item.attachmentIds === "string") {
          item.attachmentIds = item.attachmentIds.split(",");
        }
      });
      return data;
    },
    edit(data, type) {
      this.currentRow = data;
      this.isSee = true;
      if (type == "straight" || type == "burden") {
        const arr =
          data.relatedOrderIds && data.relatedOrderIds.length > 0
            ? data.relatedOrderIds.split(",")
            : [];
        const ids = arr.map((item) => Number(item));
        this.$store.commit("setSelectOrderIds", ids);
      }
      this.showDialog(type, "edit");
      this.isNewAdd = false; // 是否是新增
      // 附件id是不是字符串
      if (typeof data.attachmentIds === "string" && data.attachmentIds != "") {
        data.attachmentIds = data.attachmentIds.split(",");
      } else if (data.attachmentIds == "") {
        data.attachmentIds = [];
      }
      if (this.currentName === "MotivateAdd") {
        this.$nextTick(() => {
          this.showEdit(data, this.$refs.MotivateAdd.motivateForm);
        });
      }
      if (this.currentName === "Material") {
        this.$nextTick(() => {
          this.showEdit(data, this.$refs.Material.materialForm);
        });
      }
      if (this.currentName === "Other") {
        this.$nextTick(() => {
          this.showEdit(data, this.$refs.Other.otherForm);
        });
      }
    },
    // data要回显的数据
    // obj要回显的对象
    showEdit(data, obj) {
      for (const key in data) {
        obj[key] = data[key];
      }
    },
    showDialog(type, status) {
      this.isNewAdd = true; // 是否是新增
      switch (type) {
        case "straight":
          this.currentName = "MotivateAdd";
          this.isStraight = true;
          this.currentElement = "motivateFormRefs";
          if (!status) {
            this.$store.commit("setSelectOrderIds", []);
          }
          break;
        case "burden":
          this.currentName = "MotivateAdd";
          this.isStraight = false;
          this.currentElement = "motivateFormRefs";
          if (!status) {
            this.$store.commit("setSelectOrderIds", []);
          }
          break;
        case "material":
          this.currentName = "Material";
          this.currentElement = "materialFormRefs";
          break;
        case "other":
          this.currentName = "Other";
          this.currentElement = "otherFormRefs";
          break;
      }
      this.motivateDialog = true;
    },
    related() {
      this.relatedOrders = true;
    },
    addSubmit() {
      if (this.currentName === "MotivateAdd") {
        const data = this.$refs.MotivateAdd.motivateForm;
        const list = this.$store.state.selectOrderIds;
        this.$refs.MotivateAdd.$refs.motivateFormRefs.validate((valid) => {
          if (valid) {
            // 判断是否是新增
            if (this.settlementIncentiveList.indexOf(this.currentRow) === -1) {
              // 根据responsibleUserId查找对应的师傅名称
              const responsibleUser = this.userList.find(user => user.id === data.responsibleUserId);
              const responsibleUserIdStr = responsibleUser ? responsibleUser.userName : '';
              // 把新增对象push到数组中
              this.settlementIncentiveList.push({
                amount: data.amount, // 金额
                incentiveName: data.incentiveName, // 激励名称
                incentiveType: this.isStraight ? 1 : 0, // 激励类型
                settlementOrderId: "", // 关联的结算单ID
                attachment: "", // 附件地址，
                incentiveRemarks: data.incentiveRemarks, // 激励备注
                incentiveAttachmentIds: data.incentiveAttachmentIds, // 正负激励附件ID
                attachmentIds: data.attachmentIds, // 附件ID
                remarks: data.remarks, // 备注
                relatedOrderIds: list.length > 0 ? [...list].join(",") : "", // 关联的订单ID
                upstreamOrderNo: "", // 上游订单号
                edIncentiveId: data.edIncentiveId,
                responsibleUserId: data.responsibleUserId, // 对应师傅ID
                responsibleUserIdStr: responsibleUserIdStr, // 对应师傅名称
              });
            } else {
              // 修改数据
              const data = this.$refs.MotivateAdd.motivateForm;
              const index = this.settlementIncentiveList.indexOf(
                this.currentRow
              );
              data.relatedOrderIds =
                this.$store.state.selectOrderIds.join(",") || [];
              // 根据responsibleUserId查找对应的师傅名称
              const responsibleUser = this.userList.find(user => user.id === data.responsibleUserId);
              data.responsibleUserIdStr = responsibleUser ? responsibleUser.userName : '';
              for (const key in data) {
                this.$set(this.settlementIncentiveList[index], key, data[key]);
              }
              // this.currentRow = {}; // 清空当前行数据
            }
            this.calculateAmount(); // 计算正激励和负激励金额
            this.newAddClose();
          }
        });
      }

      if (this.currentName === "Material") {
        this.newAddmaterial();
      }

      if (this.currentName === "Other") {
        this.$refs.Other.$refs.otherFormRefs.validate((valid) => {
          if (valid) {
            const otherForm = this.$refs.Other.otherForm;
            // 判断是否是新增
            if (this.otherData.indexOf(this.currentRow) === -1) {
              // 根据responsibleUserId查找对应的师傅名称
              const responsibleUser = this.userList.find(user => user.id === otherForm.responsibleUserId);
              const responsibleUserIdStr = responsibleUser ? responsibleUser.userName : '';
              // 把新增对象push到数组中
              this.otherData.push({ ...otherForm, id: "", responsibleUserIdStr: responsibleUserIdStr });
            } else {
              const index = this.otherData.indexOf(this.currentRow);
              // 根据responsibleUserId查找对应的师傅名称
              const responsibleUser = this.userList.find(user => user.id === otherForm.responsibleUserId);
              otherForm.responsibleUserIdStr = responsibleUser ? responsibleUser.userName : '';
              for (const key in otherForm) {
                this.$set(
                  this.otherData[index],
                  key,
                  otherForm[key]
                );
              }
              // this.currentRow = {}; // 清空当前行数据
            }
            this.newAddClose();
            this.calculateOther(); // 计算其他费用
          } else {
            return false;
          }
        });
      }

    },
    // 新增物料费用列表
    newAddmaterial() {
      const materialObj = this.$refs.Material.materialForm;
      this.$refs.Material.$refs.materialFormRefs.validate((valid) => {
        if (valid) {
          // 判断是否是新增
          if (this.materialData.indexOf(this.currentRow) === -1) {
            // 根据responsibleUserId查找对应的师傅名称
            const responsibleUser = this.userList.find(user => user.id === materialObj.responsibleUserId);
            const responsibleUserIdStr = responsibleUser ? responsibleUser.userName : '';
            // 把新增对象push到数组中
            this.materialData.push({ ...materialObj, id: "", responsibleUserIdStr: responsibleUserIdStr });
          } else {
            const index = this.materialData.indexOf(this.currentRow);
            // 根据responsibleUserId查找对应的师傅名称
            const responsibleUser = this.userList.find(user => user.id === materialObj.responsibleUserId);
            materialObj.responsibleUserIdStr = responsibleUser ? responsibleUser.userName : '';
            for (const key in materialObj) {
              this.$set(this.materialData[index], key, materialObj[key]);
            }
            // this.currentRow = {}; // 清空当前行数据
          }
          this.newAddClose();
          this.calculateMaterial(); // 计算物料费用
        } else {
          return false;
        }
      });
    },
    // 计算正激励和负激励金额
    calculateAmount() {
      this.straightNum = 0;
      this.burdenNum = 0;
      this.settlementIncentiveList.forEach((item) => {
        if (item.incentiveType) {
          this.straightNum = new Big(this.straightNum)
            .plus(new Big(Number(item.amount) || 0))
            .toFixed(2);
        } else {
          this.burdenNum = new Big(this.burdenNum)
            .plus(new Big(Number(item.amount) || 0))
            .toFixed(2);
        }
      });
    },
    newAddClose() {
      // 先关闭弹窗，避免watch在关闭瞬间触发
      this.motivateDialog = false;
      // 使用nextTick确保弹窗关闭后再重置表单
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs[this.currentName] && this.$refs[this.currentName].$refs[this.currentElement]) {
          this.$refs[this.currentName].$refs[this.currentElement].resetFields();
        }
        // 清空附件列表
        if (this.$refs[this.currentName] && this.$refs[this.currentName].$refs.uploadRefs) {
          this.$refs[this.currentName].$refs.uploadRefs.fileList = [];
        }
        this.selectOrderIds = [];
        this.$store.commit("setSelectOrderIds", []);
        this.currentRow = {};
        }, 800);
      });
    },
    deleteData(row, data) {
      // 删除数据
      this[data].splice(this[data].indexOf(row), 1);
      if (data === "settlementIncentiveList") {
        this.calculateAmount(); // 计算正激励和负激励金额
      }
      if (data === "materialData") {
        this.calculateMaterial(); // 计算物料费用
      }
      if (data === "otherData") {
        this.calculateOther(); // 计算其他费用
      }
    },
    calculateMaterial() {
      if (this.materialData.length > 0) {
        this.materialNum = 0;
        this.materialData.forEach((item) => {
          const subtotal = Number(item.subtotal) || 0;
          this.materialNum = new Big(this.materialNum)
            .plus(new Big(subtotal))
            .toFixed(2)
            .toString();
        });
      } else {
        this.materialNum = 0;
      }
    },
    calculateOther() {
      if (this.otherData.length > 0) {
        this.otherTotal = 0;
        this.otherData.forEach((item) => {
          // 先判断正负激励
          if (item.incentiveType) {
            this.otherTotal = new Big(this.otherTotal)
              .plus(new Big(Number(item.amount) || 0))
              .toFixed(2);
          } else {
            this.otherTotal = new Big(this.otherTotal)
              .minus(new Big(Number(item.amount) || 0))
              .toFixed(2);
          }
        });
      } else {
        this.otherTotal = 0;
      }
    },
    // 计算管理费用
    calculateManage() {
      this.manageCont = 0;
      if (this.manageData.length > 0) {
        this.manageData.forEach((item) => {
          // 先判断正负激励
          this.manageCont = new Big(this.manageCont)
            .plus(new Big(Number(item.manageFee) || 0))
            .toFixed(2);
        });
      }
    },
    // 提交结算单
    submit(status) {
      const data = {
        ...this.addForm, // 结算批次名称&师傅id
        pendingSettlementOrderIds: this.pendingSettlementOrderIds, // 安装费用列表id
        remarks: this.remarkForm.remarks, // 备注
        settlementIncentiveList: this.handleData(this.settlementIncentiveList), // 正负激励列表参数
        totalAmount: this.pageTotalMoney,
        settlementMaterialFeeList: this.handleData(this.materialData), // 物料费用
        settlementOtherFeeList: this.handleData(this.otherData), // 其他费用
        settlementManageFeeList: this.manageData, // 管理费用
      };

      if (status) {
        data.status = status; // 状态
      }
      this.axios({
        url: "/v1/web/settlement-manage/settlement-order/add",
        method: "post",
        data,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success("提交成功！");
          this.$emit("closeDialog", true);
          this.clearData();
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
            duration: 5000,
          });
        }
      });
    },
    handleData(list) {
      if (list.length > 0) {
        list.forEach((item) => {
          item.attachmentIds = Array.isArray(item.attachmentIds) ? item.attachmentIds.join(",") : "";
          if (item.relatedOrderIds && Array.isArray(item.relatedOrderIds)) {
            item.relatedOrderIds =
              item.relatedOrderIds.length > 0
                ? item.relatedOrderIds.join(",")
                : "";
          }
        });
        return list;
      }
    },
    editSubmit(status) {
      const data = {
        ...this.addForm, // 结算批次名称&师傅id
        pendingSettlementOrderIds: this.pendingSettlementOrderIds, // 安装费用列表id
        remarks: this.remarkForm.remarks, // 备注
        totalAmount: this.pageTotalMoney,
        settlementManageFeeList: this.manageData, // 管理费用
        settlementIncentiveList: this.handleData(this.settlementIncentiveList), // 正负激励列表参数
        settlementMaterialFeeList: this.handleData(this.materialData), // 物料费用
        settlementOtherFeeList: this.handleData(this.otherData), // 其他费用
      };
      delete data.isSee;
      delete data.id;
      if (status) {
        data.status = status; // 状态
      }else{
        data.status = null; // 状态
      }
      this.axios({
        url: `/v1/web/settlement-manage/settlement-order/edit/${this.addForm.id}`,
        method: "post",
        data,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success("提交成功！");
          this.$emit("closeDialog", false);
          this.clearData();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 清空列表数据
    clearData() {
      this.remarkForm = {
        remarks: "", // 备注
      };
      this.settlementIncentiveList = []; // 正负激励列表
      this.materialData = []; // 物料费用列表
      this.otherData = []; // 其他费用列表
      this.manageData = []; // 管理费用列表
      this.isManagementFeeGroupLeader = false; // 重置是否是管理费群组管理员
      this.pendingSettlementOrderIds = []; // 安装费用列表id
      this.installationCost = 0;
      this.burdenNum = 0;
      this.straightNum = 0;
      this.otherTotal = 0;
      this.materialNum = 0;
      this.manageCont = 0;
    },
    // 关联订单提交
    relatedOrdersSubmit() {
      this.$store.commit(
        "setSelectOrderIds",
        this.$refs.relatedRefs.selectData
      ); // 提交时将选择的数据id提交到vuex
      this.relatedOrders = false;
    },
    // 应用最新数据及群组
    handleApplyLatestGroup(module) {
      const moduleName = module === 'installationFee' ? '安装费' : '管理费';
      this.$confirm(
        `是否确认应用最新数据及群组？将根据最新群组定义重新获取${moduleName}数据`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          // 记录开始时间，确保loading至少显示0.5秒
          const startTime = Date.now();
          const minLoadingTime = 500; // 最小loading时间：0.5秒
          
          // 设置loading状态
          if (module === 'installationFee') {
            this.installationFeeLoading = true;
          } else if (module === 'manageFee') {
            this.manageFeeLoading = true;
          }
          
          this.axios({
            url: `/v1/web/settlement-manage/settlement-order/applyLatestGroup`,
            method: 'post',
            params: {
              settlementOrderId: this.addForm.id,
              module: module,
            },
          })
            .then((res) => {
              if (res.data && res.data.code === 200) {
                this.$message.success('应用最新数据及群组成功！');
                // 直接使用返回的数据填充，不再次调用后端
                const data = res.data.data || {};
                if (module === 'installationFee') {
                  // 填充安装费数据
                  this.contTableData = data.pendingSettlementOrderList || [];
                  this.contTableDataFiltered = this.contTableData;
                  this.contTableDataGroupTotal = this.tableDataGroupAndTotal(
                    this.contTableData,
                    'installerIdStr',
                    'installFee'
                  );
                  this.totalsData.lineLength = this.contTableData.reduce((acc, item) => {
                    if (item.lineLength !== undefined && item.lineLength !== null) {
                      return acc.plus(new Big(item.lineLength || 0));
                    }
                    return acc;
                  }, new Big(0));
                  this.totalsData.addOutlay = this.contTableData.reduce((acc, item) => {
                    if (item.addOutlay !== undefined && item.addOutlay !== null) {
                      return acc.plus(new Big(item.addOutlay || 0));
                    }
                    return acc;
                  }, new Big(0));
                  // 更新安装费ID列表
                  this.pendingSettlementOrderIds = [];
                  this.contTableData.forEach((item) => {
                    if (item.id) {
                      this.pendingSettlementOrderIds.push(item.id);
                    }
                  });
                  this.calculateInstall();
                } else if (module === 'manageFee') {
                  // 填充管理费数据
                  this.manageData = data.settlementManageFeeList || [];
                  this.manageDataGroupTotal = this.tableDataGroupAndTotal(
                    this.manageData,
                    'installerIdStr',
                    'manageFee'
                  );
                  this.calculateManage();
                }
                // 重新计算总金额
                this.calculateAmount();
              } else {
                const errorMsg = (res.data && res.data.message) ? res.data.message : '应用最新数据及群组失败';
                this.$message.error(errorMsg);
              }
            })
            .catch((error) => {
              let errorMsg = '应用最新数据及群组失败';
              if (error.response && error.response.data && error.response.data.message) {
                errorMsg += '：' + error.response.data.message;
              } else if (error.message) {
                errorMsg += '：' + error.message;
              }
              this.$message.error(errorMsg);
            })
            .finally(() => {
              // 计算已用时间，确保loading至少显示0.5秒
              const elapsedTime = Date.now() - startTime;
              const remainingTime = Math.max(0, minLoadingTime - elapsedTime);
              
              setTimeout(() => {
                // 无论成功或失败，都要关闭loading
                if (module === 'installationFee') {
                  this.installationFeeLoading = false;
                } else if (module === 'manageFee') {
                  this.manageFeeLoading = false;
                }
              }, remainingTime);
            });
        })
        .catch(() => {
          // 用户取消操作
        });
    },
    // 刷新模块数据
    refreshModuleData(module) {
      if (!this.addForm.id) {
        return;
      }
      this.axios({
        url: `/v1/web/settlement-manage/settlement-order/getModuleData`,
        method: 'get',
        params: {
          id: this.addForm.id,
          module: module === 'installationFee' ? 'pendingSettlementOrderList' : 'settlementManageFeeList',
        },
      })
        .then((res) => {
          if (res.data && res.data.code === 200) {
            if (module === 'installationFee') {
              const data = res.data.data || {};
              this.contTableData = data.pendingSettlementOrderList || [];
              this.contTableDataFiltered = this.contTableData;
              this.contTableDataGroupTotal = this.tableDataGroupAndTotal(
                this.contTableData,
                'installerIdStr',
                'installFee'
              );
              this.totalsData.lineLength = this.contTableData.reduce((acc, item) => {
                if (item.lineLength !== undefined && item.lineLength !== null) {
                  return acc.plus(new Big(item.lineLength || 0));
                }
                return acc;
              }, new Big(0));
              this.totalsData.addOutlay = this.contTableData.reduce((acc, item) => {
                if (item.addOutlay !== undefined && item.addOutlay !== null) {
                  return acc.plus(new Big(item.addOutlay || 0));
                }
                return acc;
              }, new Big(0));
              this.calculateInstall();
            } else if (module === 'manageFee') {
              const data = res.data.data || {};
              this.manageData = data.settlementManageFeeList || [];
              this.manageDataGroupTotal = this.tableDataGroupAndTotal(
                this.manageData,
                'installerIdStr',
                'manageFee'
              );
              this.calculateManage();
            }
            // 重新计算总金额
            this.calculateAmount();
          }
        })
        .catch((error) => {
          let errorMsg = '刷新数据失败';
          if (error.response && error.response.data && error.response.data.message) {
            errorMsg += '：' + error.response.data.message;
          } else if (error.message) {
            errorMsg += '：' + error.message;
          }
          this.$message.error(errorMsg);
        });
    },
  },
};
</script>

<style scoped>
.new_settlement {
  height: 100%;
  padding: 20px;
  background-color: rgb(238, 238, 238);
  border-radius: 8px;
}
.settlement_top {
  background-color: #fff;
  padding: 20px 0;
  border-radius: 8px;
}
.top_model {
  padding-inline: 20px;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
}
.settlementName {
  margin-left: 5px;
  margin-right: 15px;
}
.money {
  margin-left: 5px;
}
.install_cont {
  background-color: #fff;
  margin-top: 20px;
  border-radius: 8px;
  padding: 20px;
}
.install_title {
  margin-bottom: 10px;
}

.install_title span {
  font-weight: bold;
}
.motivate {
  display: flex;
  justify-content: space-between;
}
</style>
